/* eslint-disable import/prefer-default-export */
export const TSP = {
  NEAREST_NEIGHBOUR: 'NEAREST_NEIGHBOUR',
  NEAREST_INSERTION: 'NEAREST_INSERTION',
  FARTHEST_INSERTION: 'FARTHEST_INSERTION',
  CHEAPEST_INSERTION: 'CHEAPEST_INSERTION',
  RANDOM_INSERTION: 'RANDOM_INSERTION',
  CONVEX_HULL: 'CONVEX_HULL',
  TWO_OPT: '2-OPT_INVERSION',
};
